import React from "react";
import styles from "./opps-bar.module.scss";
import { StatusBar } from "../StatusBar";
import type { OppsOrderType, OppType } from "@whatslly/types/SfQueryApiResponse";
import { Tooltip } from "@whatslly/ui-components/Tooltip";
import { buildEntityLink } from "@whatslly/commons/entityUtils";
import type { UserType } from "@whatslly/types/User";
import { observer } from "mobx-react-lite";
import classnames from "classnames";

export const OppsBar: React.FC<{
  opps?: OppType[];
  oppsOrder?: OppsOrderType[];
  user?: UserType;
}> = observer(({ opps, oppsOrder, user }) => {
  return (
    <div className={styles.opRows}>
      {opps?.map((op, index) => {
        return (
          <div key={index} className={styles.opRow}>
            <div className={styles.opLink}>
              <Tooltip delay={300} value={<span>{op.Name}</span>} placement="bottom">
                {user?.hideCrmLinks ? (
                  <span className={classnames(styles.link, styles.disabled)}>{op.Name}</span>
                ) : (
                  <a target="sfdc" href={buildEntityLink({ baseUrl: user?.base, id: op.Id, type: "opportunity" })} className={styles.link}>
                    {op.Name}
                  </a>
                )}
              </Tooltip>
            </div>
            <StatusBar
              allowChangeItem={user?.allowChangeOppStage}
              className={styles.oppsBar}
              initCurrentItemValue={op.StageName}
              items={op.OpStages || oppsOrder}
              parentItemId={op.Id}
              parentItemType={"Opportunity"}
            />
          </div>
        );
      })}
    </div>
  );
});
